import React from 'react'

import { useLongPress } from '@bettermode/common/hooks'
import { isTouchDevice } from '@bettermode/common/user-agent'

interface Props {
  children: React.ReactNode
  onSelected?: () => void
}

export const ChatMessageContextMenu = ({ children, onSelected }: Props) => {
  const {
    isSelected,
    handlePressStart,
    handlePressEnd,
    handleContextMenu,
    handleTouchMove,
  } = useLongPress({
    onLongPress: onSelected,
  })

  if (!isTouchDevice()) {
    return <>{children}</>
  }

  // To avoid text selection on long press.
  // Removing styles when selected to allow the default context menu to work
  // on the SelectedMessageOverlay.
  const addContextMenuStyle = !isSelected

  return (
    <div
      onMouseDown={handlePressStart}
      onMouseUp={handlePressEnd}
      onContextMenu={handleContextMenu}
      onTouchStart={handlePressStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handlePressEnd}
      onTouchCancel={handlePressEnd}
      style={
        addContextMenuStyle
          ? {
              WebkitUserSelect: 'none',
              WebkitTouchCallout: 'none',
              userSelect: 'none',
            }
          : {}
      }
    >
      {children}
    </div>
  )
}
